<template>
  <div>
    <v-container v-if="user.role === 'advertiser'" class="mb-4 pa-0" style="max-width: 1200px;">
      <div class="mb-5 mt-3 d-flex flex-wrap">
        <h2 class="headline">Dashboard</h2>
      </div>
      <v-row class="wrap">
        <div class="col-sm-6">
          <v-card class="pa-5">
            <h2 class="title mb-4">Product Guide</h2>
            <div v-if="permissions.includes('product_guide')">
              <v-btn
                @click="viewProductGuide"
                color="primary"
                :block="$vuetify.breakpoint.smAndDown"
              >View Listing</v-btn>
            </div>
            <div v-else class="body-2">
              You do not have access to the Product Guide. Please email us at <a href="mailto:info@concretedecor.net">info@concretedecor.net</a> for more information about how you can be included.
            </div>
          </v-card>
        </div>
        <div class="col-sm-6">
          <v-card class="pa-5">
            <h2 class="title mb-4">Training Guide</h2>
            <div v-if="permissions.includes('trainings')">
              <v-container class="grid-list-lg pa-0">
                <v-layout class="row wrap" :class="{'mx-0': $vuetify.breakpoint.smAndDown}">
                  <v-btn 
                    @click="viewTrainingGuide" color="primary"
                    class="my-2"
                    :class="{'mx-2': !$vuetify.breakpoint.smAndDown}"
                    :block="$vuetify.breakpoint.smAndDown"
                  >View Training Guide</v-btn>
                  <v-btn 
                    @click="$router.push('/trainings')"
                    class="my-2"
                    :class="{'mx-2': !$vuetify.breakpoint.smAndDown}"
                    color="primary"
                    :block="$vuetify.breakpoint.smAndDown"
                  >View Trainings</v-btn>
                </v-layout> 
              </v-container>
            </div>
            <div v-else class="body-2">
              You do not publish events in the training guide. Please email us at <a href="mailto:info@concretedecor.net">info@concretedecor.net</a> for more information about how to start advertising your events.
            </div>
          </v-card>
        </div>
      </v-row>
      <v-row class="wrap">
        <div class="col-sm-6">
          <v-card class="pa-5">
            <h2 class="title mb-4">Banner Advertising</h2>
            <div v-if="permissions.includes('web_ads')">
              <v-container class="grid-list-lg pa-0">
                <v-layout class="row wrap" :class="{'mx-0': $vuetify.breakpoint.smAndDown}">
                  <v-btn
                    @click="$router.push('/web_ads')"
                    class="my-2"
                    :class="{'mx-2': !$vuetify.breakpoint.smAndDown}"
                    color="primary"
                    :block="$vuetify.breakpoint.smAndDown"
                  >Manage Web Ads</v-btn>
                  <v-btn
                    @click="$router.push('/reports')"
                    class="my-2"
                    :class="{'mx-2': !$vuetify.breakpoint.smAndDown}"
                    color="primary"
                    :block="$vuetify.breakpoint.smAndDown"
                  >View Web Ad Stats</v-btn>
                </v-layout>
              </v-container>
            </div>
            <div v-else class="body-2">
              You cannot publish ads on the website. Please email us at <a href="mailto:info@concretedecor.net">info@concretedecor.net</a> for more information about how to start advertising.
            </div>
          </v-card>
        </div>
        <div class="col-sm-6">
          <v-card class="pa-5">
            <h2 class="title mb-4">Contact Info</h2>
            <div class="body-2">
              <div class="mb-2">
                <div>Bent Mikkelsen</div>
                <div class="grey--text">Account Manager</div>
              </div>
              <div><v-icon size="16" class="mr-2">mdi-phone</v-icon> <a href="tel:8779358906">877-935-8906</a></div>
              <div><v-icon size="16" class="mr-2">mdi-email</v-icon> <a href="mailto:bent@concretedecor.net">bent@concretedecor.net</a></div>
            </div>
          </v-card>
        </div>
      </v-row>
    </v-container>
    <v-container v-else class="mb-4 pa-0">
      <div class="mb-7 mt-3 d-flex flex-wrap">
        <h2 class="headline">Dashboard</h2>
      </div>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  data: () => ({

  }),
  methods: {
    viewTrainingGuide () {
      this.$store.state.active_profile_tab = 2;
      this.$router.push('/company_profiles')
    },
    viewProductGuide () {
      this.$store.state.active_profile_tab = 1;
      this.$router.push('/company_profiles')
    }
  },
  computed: {
    ...mapGetters(["user", "permissions"]),
  }
}
</script>